<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h2 class="card-title">Snowflakes</h2>
              <p class="category">*Christmas 2018 Gifts*</p>
            </div>
            <div class="card-content">
              <img src="../../../../../static/img/Snowflakes/1.jpg" alt="A group of 4 snowflakes illuminated" style="border-radius:30px;margin-bottom:20px">
              <p>This Christmas decoration was made with the intent of mass producing these for friends/family. Didn't necessarily turn out that way...but I ended up building around 15 or so for friends/family during Christmas 2018 🎄</p>
            </div>
          </div>
        </div>
  </div>
  <!-- YouTube Demos -->
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Snowflake Demo</h4>
            </div>
            <div class="card-content">
              <youtube :video-id="videoIdOne" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
  </div>

  <!-- Demo Stuff -->
  <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">CAD Model</h4>
            </div>
            <div class="card-content">
              <p>The necessary STL files are provided <a href="https://github.com/mclemcrew/led-snowflake/tree/master/Snowflake%20Design" target="_blank">here</a> so you can print your own snowflake! Feel free to modify it how you see fit! :D</p>
            </div>
            <div class="card-header">
              <h4 class="card-title">Directions</h4>
            </div>
            <div class="card-content">
             <p>
               Currently, the directions are laid out in a <a href="https://github.com/mclemcrew/led-snowflake/blob/master/Snowflake%20Directions.pdf" target="_blank">PDF</a> so you can download them at your lesiure and take them with you wherever you build it. Everything should be explained thoroughly, but if you have some questions or whatnot, feel free to drop a comment and let me know!
             </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Built With</h4>
            </div>
            <div class="card-content">
              <ul style="font-size:15px">
                <li>[Arduino Nano] - The microcontroller used</li>
                <li>[WS2812B RGB 5050 LED Strip] – LEDs inside the snowflake</li>
                <li>[SPDT (Single Pole, Double Throw) Switch]</li>
                <li>[Momentary Push Button]</li>
              </ul>
            </div>
          </div>
        </div>
    </div>

    <!-- Gallery -->
    <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Gallery</h4>
            </div>
            <div class="card-content" style="display: flex;
                  flex-flow: row wrap;
                  justify-content: center;">
              <!-- Image Gallery -->
              <gallery :images="images" :index="index" @close="index = null"></gallery>
              <div
                class="image"
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
              ></div>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      videoIdOne: 'ja2KT82nnUE',
      videoIdTwo: 'lzz4zSDs-3s',
      images: [
        '../../../../../static/img/Snowflakes/1.jpg',
        '../../../../../static/img/Snowflakes/2.jpg',
        '../../../../../static/img/Snowflakes/3.jpg',
        '../../../../../static/img/Snowflakes/4.jpg',
        '../../../../../static/img/Snowflakes/5.jpg',
        '../../../../../static/img/Snowflakes/6.jpg',
        '../../../../../static/img/Snowflakes/7.jpg',
        '../../../../../static/img/Snowflakes/8.jpg'
      ],
      index: null
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('/\\o/ we are watching!!!')
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>
<style>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Projects/Snowflake.vue